module.exports = __webpack_public_path__ + "img/private-napolimania-salad-1.60a0ddc1.jpg";